<template>
    <div :class="['modal', 'fade', { 'topmost-zindex': isTopMost }]" id="messageGlobalDialog" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scv" role="document">
            <div class="modal-content modal-message-content-scv">
                <div class="modal-header modal-header-scv-cmn" style="width: 100%">
                    <div class="modal-header-text-box-scv" style="width: 100%">
                        <span class="modal-header-text-scv">
                            {{GetType(messageType)}}
                        </span>
                    </div>
                    <div class="btn-scv-close">
                        <button type="button" class="btn-scv-close message-close" role="button" @click="onBtnOk()">
                            <div class="icon-font-slategray">
                                <i class="icon-delete"></i>
                            </div>
                        </button>
                    </div>
                </div>
                <div class="modal-body modal-body-scv">
                    <template v-if="IsMultiLine(messageText) === true && isScroll">
                        <div class="d-flex flex-row">
                            <MessageGuideIcon :iconType="messageType" v-show="!hideIcon"/>
                            <span v-html="messageText" style="margin-top: 4px; overflow-y: auto; min-height:50px; max-height:500px; word-break: break-all;"></span>
                        </div>
                    </template>
                    <template v-else-if="IsMultiLine(messageText) === true">
                        <div class="d-flex flex-row">
                            <MessageGuideIcon :iconType="messageType" v-show="!hideIcon" />
                            <span v-html="messageText" style="margin-top: 4px;"></span>
                        </div>
                    </template>
                    <template v-else>
                        <div class="d-flex flex-row align-items-center">
                            <MessageGuideIcon :iconType="messageType" v-show="!hideIcon" />
                            <span v-html="messageText"></span>
                        </div>
                    </template>
                </div>
                <div class="modal-footer modal-footer-scv">
                    <div class="d-flex justify-content-center">
                        <div zero-font>
                            <button id="btnOk_messageGlobalDialog" type="button" class="btn-scv-blue" @click="onBtnOk()">{{btn_ok}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import $ from "jquery";
    import { MessageType } from '@/models/Message/MessageType';
    import MessageGuideIcon from '@/components/Popup/MessageGuideIcon.vue';
    import { BootstrapUtil } from 'lib-vue-v2/util';

    @Options({
        emits: [
            'onSelectOK'
        ],
        methods: {
            GetType(messageType: number): string {
                if ("" != this.title) {
                    //タイトル指定がある場合
                    return this.title;
                }
                if (messageType === MessageType.Error) {
                    return "エラー";
                }
                else if (messageType === MessageType.Warning) {
                    return "警告";
                }
                return "情報";
            },
            IsMultiLine(messageText: string): boolean {
                return (0 <= messageText.indexOf('<br'));
            }
        },
        components: {
            MessageGuideIcon
        },
    })

    // メッセージダイアログコンポーネント
    export default class MessageGlobalDialog extends Vue {
        private messageType: MessageType = MessageType.Information;
        private messageText = "";
        private callback: any = null;
        private isScroll = false;   /* 現在外から指定出来ず。指定する場合セッターを用意する？ */
        private hideIcon = false;
        private btn_ok = "OK";
        private title = "";
        private hideResolve: ((value?: void | PromiseLike<void>) => void) | null = null;
        private isTopMost = false;

        /**
         * @brief   マウント
         */
        public mounted(): void {
            const el = document.getElementById('messageGlobalDialog');
            if(null != el) {
                el.addEventListener('shown.bs.modal', () => {
					// [はい]にフォーカスをあてる
                    $('#btnOk_messageGlobalDialog').focus();
                });
				
				// 画面が閉じるとき
                el.addEventListener('hidden.bs.modal', () => {
                    this.$emit('onSelectOK', this.callback);

                    this.messageType = MessageType.Information;

                    this.messageText = "";

                    this.isScroll = false;

                    this.callback = null;

                    this.hideIcon = false;

                    this.btn_ok = "OK";

                    this.title = "";

                    if (this.hideResolve) {
                        this.hideResolve();
                        this.hideResolve = null;
                    }
                });
            }
        }

        /**
         * @brief   OKボタン押下
         */
        public onBtnOk(): void {
            BootstrapUtil.hideModal("messageGlobalDialog");

            // ※コールバック関数（this.callback）は画面が閉じたときに実行する。
        }

        /*
         * アイコンを非表示に設定
         */
        public HideIcon(): void {
            this.hideIcon = true;
        }

        /*
         * メッセージの表示
         * @param[in] strHTML : メッセージ内容(HTML)
         * @param[in] type : アイコンの種類
         * @param[in] callback : OK押下後のコールバック関数
         *              ★Functionクラスで指定すること。コールバック不要ならnull
         * @param[in] okText : OKボタンの文言(undefined : OK)
         * @param[in] isTopMost : ローディングよりも上に出したい場合に使用。（基本使用禁止。セッションタイムアウトによるログアウト等、強制的に表示したいときのみ使用）
         */
        public Show(strText: string, type: MessageType, callback: any, caption: string | undefined = undefined, okText: string | undefined = undefined, isTopMost:boolean = false): void {
            if (0 < this.messageText.length) {
                // 現在表示中
                return;
            }
            this.messageText = strText;
            this.messageType = type;
            this.callback = callback;

            if (undefined == caption || "" == caption) {
                this.title = "";
            }
            else {
                this.title = caption;
            }

            if (undefined == okText || "" == okText) {
                this.btn_ok = "OK";
            }
            else {
                this.btn_ok = okText;
            }

            this.isTopMost = false;
            BootstrapUtil.showModal("messageGlobalDialog");
        }

        /*
         * メッセージの隠匿
         */
        public Hide(): void {
            BootstrapUtil.hideModal("messageGlobalDialog");
        }

        /*
         * メッセージの隠匿
         * メッセージ終了時のコールバック処理が完了するまで待機する場合に使用
         */
        public async HideAsync(): Promise<void>{
            if (this.messageText.length === 0) {
                return;
            }

            return await new Promise(resolve => {
                this.hideResolve = resolve;
                this.Hide();
            });
        }
    }

</script>

<style scoped>
    .message-close {
        background-color: #fff;
        border: none;
    }

    .topmost-zindex {
        z-index: 2147483647;
    }
</style>
